import React from 'react';
import { useField } from 'formik';

// components
import { TextArea } from 'components/inputs/TextArea';

export interface CustomTextAreaProps {
  name: string;
  id?: string;
  label?: string;
  placeholder?: string;
  width?: number;
  shouldBeTouched?: boolean;
  onFocus?: () => void;
  rows?: number;
}

export const TextAreaField = (props: CustomTextAreaProps) => {
  const [field, meta] = useField(props.name);
  const isError = props.shouldBeTouched
    ? meta.touched && meta.error
    : meta.error;

  return <TextArea {...props} {...field} isError={!!isError} />;
};
